import { MeetingContainerAPI } from "@kalyzee/kast-web-sdk";
import { isBoardSession } from "../helpers/board";
import { useLocalOrRemoteMedia } from "./ovenmedia";
import { useCallback } from "react";
import { MeetingSession } from "@kalyzee/kast-web-sdk/websocket";
import { useMeetingSelector } from "./meeting";

export const useBoardMedia = (meetingAPI?: MeetingContainerAPI) => {
  const [rooms] = useMeetingSelector(meetingAPI, (state) => state.rooms);
  return useLocalOrRemoteMedia(
    meetingAPI,
    useCallback((s: MeetingSession) => isBoardSession(s, rooms), [rooms]),
  );
};